module.exports = __webpack_public_path__ + "static/media/rosie-cards.cc0d2280.png";